import api from './api';

const organizationService = {
  // Récupérer toutes les organisations avec filtres et pagination
  getOrganizations: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/organizations?${queryString}` : '/organizations';
    
    return await api.get(url);
  },

  // Récupérer une organisation par ID
  getOrganizationById: async (id) => {
    return await api.get(`/organizations/${id}`);
  },

  // Créer une nouvelle organisation
  createOrganization: async (organizationData) => {
    return await api.post('/organizations', organizationData);
  },

  // Mettre à jour une organisation
  updateOrganization: async (id, organizationData) => {
    return await api.put(`/organizations/${id}`, organizationData);
  },

  // Supprimer une organisation
  deleteOrganization: async (id) => {
    return await api.delete(`/organizations/${id}`);
  },

  // Télécharger un logo
  uploadLogo: async (id, formData) => {
    return await api.post(`/organizations/${id}/upload-logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Ajouter un membre à l'organisation
  addMember: async (id, memberData) => {
    return await api.post(`/organizations/${id}/members`, memberData);
  },

  // Retirer un membre de l'organisation
  removeMember: async (id, memberId) => {
    return await api.delete(`/organizations/${id}/members/${memberId}`);
  },

  // Récupérer les membres d'une organisation
  getOrganizationMembers: async (id) => {
    return await api.get(`/organizations/${id}/members`);
  },

  // Récupérer les statistiques des organisations
  getOrganizationStats: async () => {
    return await api.get('/organizations/stats');
  },

  // Récupérer les statistiques d'une organisation spécifique
  getOrganizationStatsById: async (id) => {
    return await api.get(`/organizations/${id}/stats`);
  },

  // Vérifier une organisation (admin)
  verifyOrganization: async (id) => {
    return await api.put(`/organizations/${id}/verify`);
  },

  // Annuler la vérification d'une organisation (admin)
  unverifyOrganization: async (id) => {
    return await api.put(`/organizations/${id}/unverify`);
  },

  // Rechercher des organisations par localisation
  searchByLocation: async (params) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    return await api.get(`/organizations/search/location?${queryParams.toString()}`);
  },

  // Rechercher des organisations (recherche textuelle)
  searchOrganizations: async (query, params = {}) => {
    const queryParams = new URLSearchParams({ q: query });
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    return await api.get(`/organizations/search?${queryParams.toString()}`);
  },

  // Récupérer le profil public d'une organisation
  getOrganizationProfile: async (id) => {
    return await api.get(`/organizations/${id}/profile`);
  },

  // Récupérer les missions d'une organisation
  getOrganizationMissions: async (id, params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/organizations/${id}/missions?${queryString}` : `/organizations/${id}/missions`;
    
    return await api.get(url);
  },

  // Récupérer les avis sur une organisation
  getOrganizationReviews: async (id) => {
    return await api.get(`/organizations/${id}/reviews`);
  },

  // Ajouter un avis sur une organisation
  addOrganizationReview: async (id, reviewData) => {
    return await api.post(`/organizations/${id}/review`, reviewData);
  },

  // Suivre une organisation
  followOrganization: async (id) => {
    return await api.post(`/organizations/${id}/follow`);
  },

  // Ne plus suivre une organisation
  unfollowOrganization: async (id) => {
    return await api.delete(`/organizations/${id}/follow`);
  },

  // Récupérer les organisations suivies
  getFollowedOrganizations: async () => {
    return await api.get('/organizations/followed');
  },

  // Mettre à jour le rôle d'un membre
  updateMemberRole: async (id, memberId, role) => {
    return await api.put(`/organizations/${id}/members/${memberId}/role`, { role });
  }
};

export default organizationService;